
import { defineComponent, ref, reactive, computed } from 'vue'
import type { FormInstance, FormRules } from "element-plus";
import { errManager, showNotification } from "@/core/config/Tools";
//services
import GlobalService from '@/core/services/GlobalService';
import functionService from '@/core/services/FunctionService';
//libraries
import { useI18n } from "vue-i18n/index";
import moment from 'moment';

export default defineComponent({
    props:{
        itemFunction: {
            type: null,
            required: false,
            default: () => ({})
        }
    },
    setup(props, { emit }) {
        const { t } = useI18n();
        const loading = ref(false);
        const titleDialog = ref('');
        const isModalVisible = ref(false);
        const form = reactive<any>({});
        const ruleFormRef = ref<FormInstance>();
        const rules = reactive<FormRules>({});

        const activeText = computed(() => (form.mstatus.id.toString() === '1' ? t('active') : t('inactive')))

        const openModal = () => {
            isModalVisible.value = true
        };

        const onOpen = () => {
            const hasData = props.itemFunction && Object.keys(props.itemFunction).length > 0;
            titleDialog.value = hasData ? t('edit') : t('register')
            if (hasData) onEdit();
        };

        const onClosed = () => {
            resetForm(ruleFormRef.value)
            Object.keys(form).forEach(key => delete form[key]);
        };

        const resetForm = (formEl: FormInstance | undefined) => {
            if (!formEl) return;
            formEl.resetFields();
        };

        const submitForm = async (formEl: FormInstance | undefined) => {
            if (!formEl) return;
            const valid = await formEl.validate();
            if(!valid) return;

            const hasData = props.itemFunction && Object.keys(props.itemFunction).length > 0;
            if(hasData)
                await update();
            else 
                await save();
        };

        const onRepeat = (data: any) => {
            loading.value = false;
                showNotification(data);
                if(data.status == 'success') {
                    isModalVisible.value = false;
                    emit("onResponseAddEditFunction", data);
                }
        }

        const update = async() => {
            loading.value = true;
            await GlobalService.update('functions', form.idfunction, 'update', form)
            .then((res)=>{
                onRepeat(res.data)
            }).catch(({ response }) => {
                loading.value = false;
                errManager(response);
            })
        }

        const save = async () => {
            loading.value = true
            await functionService.postOptions('save', form)
                .then((res) => {
                    onRepeat(res.data);
                }).catch(({ response }) => {
                    loading.value = false;
                    errManager(response);
                })
        };

        const onEdit = async () => {
            loading.value = true;
            await GlobalService.get('api', `functions/${props.itemFunction?.idfunction}/edit`)
            .then((res) => {
                 Object.assign(form, { ...res.data })
                 loading.value = false;
            }).catch(({ response }) => {
                loading.value = false;
                errManager(response);
            })
        }

        return{
            t,
            loading,
            titleDialog,
            isModalVisible,
            form,
            rules,
            ruleFormRef,
            //event
            openModal,
            onOpen,
            onClosed,
            submitForm,
            activeText

        }
        
    },
})
